import React from 'react'

const ForsageFooter = ({ item }) => {

    return (
        <>
            <div className='md:my-10 container mx-auto px-4  md:container md:mx-auto'>
                {
                    item.map((items, index) => (
                        <div key={index} className='md:flex text-center grid grid-rows-4 grid-flow-col md:justify-between  items-center'>
                            <div className='mx-auto md:m-0'>
                                <img className='mx-auto ' src={items.logo} alt="footer-logo" />
                                <p className='text-gray-400 text-xl w-[300px] py-5 font-medium'>{items.title}</p>
                            </div>
                            <div className='text-white mx-auto flex gap-5 text-xl font-medium'>
                                <span className='text-gray-400'>{items.busd}</span>
                                <span>{items.item}</span>
                            </div>
                            <div className=' flex mx-auto md:m-0 justify-between items-center gap-20'>
                                <div className=' flex justify-between items-center gap-5' >
                                    <img className='w-10' src={items.busdIcon} alt="busdIcon" />
                                    <div className='text-xl font-medium text-white'>
                                        <p>Forsage</p>
                                        <p>BUSD</p>
                                    </div>
                                </div>
                                <div className='text-white flex md:flex md:justify-between items-center gap-5'>
                                    <span>{items.supportIcon}</span>
                                    <div className='text-xl font-medium text-white'>
                                        <p>Forsage</p>
                                        <p>BUSD</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default ForsageFooter